import {
  HeadingTitle,
  SubHeadingTitle,
} from "../../../../components/shared/index";
import styles from "./checkoutpayment.module.css";
const PaymentSection = ({
  paymentOptions,
  selectedPayment,
  setSelectedPayment, 
}) => {
  return (
    <div className={styles.paymentSection}>
      <HeadingTitle text="Payment" style={styles.heading} />
      <div className={styles.paymentOptions}>
        {paymentOptions?.map((option) => (
          <div
            key={option.id}
            className={styles.paymentOption}
            onClick={() => setSelectedPayment(option.id)}
          >
            <div
              className={`${styles.radioButton} ${
                selectedPayment === option.id ? styles.radioButtonActive : ""
              }`}
            >
              {selectedPayment === option.id && (
                <div className={styles.radioButtonInner}></div>
              )}
            </div>
            <SubHeadingTitle
              subTitle={option.label}
              style={styles.paymentLabel}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
export default PaymentSection;